const COUNTER_ID = 92514939;
const TRACKING_DELAY = 100;

export const trackGoal = (goalName: string, params?: Record<string, unknown>): void => {
  if (typeof window === "undefined") return;

  if (typeof window.ym !== "function") {
    return;
  }

  window.ym(COUNTER_ID, "reachGoal", goalName, params);

  if (process.env.NODE_ENV === "development") {
    console.log("[Analytics] Goal tracked:", goalName, params);
  }
};

export const trackExternalLink = (
  url: string,
  goalName: string,
  params?: Record<string, unknown>,
): void => {
  trackGoal(goalName, params);

  setTimeout(() => {
    window.location.href = url;
  }, TRACKING_DELAY);
};

export const trackAnchorLink = (
  href: string,
  goalName: string,
  params?: Record<string, unknown>,
): void => {
  trackGoal(goalName, params);

  setTimeout(() => {
    const targetId = href.replace("#", "");
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, TRACKING_DELAY);
};

export const handleTrackedClick = (
  e: React.MouseEvent | null,
  href: string,
  goalName: string,
  params?: Record<string, unknown>,
): void => {
  const isAnchor = href.startsWith("#");
  const isExternal = !isAnchor && href !== "#";

  if (isAnchor) {
    e?.preventDefault();
    trackAnchorLink(href, goalName, params);
  } else if (isExternal) {
    e?.preventDefault();
    trackExternalLink(href, goalName, params);
  }
};
